import '../../lightgallery/sass/lightgallery.scss';
import '../../lightgallery/js/lightgallery';
import '../../lightgallery/js/lg-thumbnail';
import '../../lightgallery/js/lg-autoplay';
import '../../lightgallery/js/lg-share';

export function applyTo(selector, options) {
    document.querySelectorAll(selector).forEach(function(element) {
        lightGallery(element, options);
    });
}

